// extracted by mini-css-extract-plugin
export default {"duration":"O0ioTcoaMAeJLtCORBPO"};